// extracted by mini-css-extract-plugin
export default {"main__title":"ReviewsBlock_main__title__SfGLO","main__subtitle":"ReviewsBlock_main__subtitle__kTbxW"};